import React from 'react';
import { TourGuideParagraph } from '../TourGuideParagaph';

export const Segment1 = () => (
    <TourGuideParagraph>
        <p>WELCOME TO THE PEARL™</p>
        <p>where THE WORLD IS YOUR OYSTER.</p>
    </TourGuideParagraph>
);
